import $ from "jquery";
export function inlineSVG() {
  var svgImgSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ".svg";
  // Push SVG to inline so we can edit them
  $("img" + svgImgSelector).each(function () {
    var $this = $(this);
    $.get($this.attr("src"), function (data) {
      var $svg = $(data).find("svg").removeAttr("xmlns:a");
      $this.replaceWith($svg);
    }, "xml");
  });
}